<script>
    export let item;

    function itemTypeText() {
        switch (item.entity) {
            case 'SoundLocation':           
                return (item.wpn2_type == 'alfx_sensor') ? "ALFX Sensor" : "Pinpointed Sound Source";

            default:
                return (item.wpn2_type != undefined) ? item.wpn2_type : "";
        }
    }

</script>

<!-- <div id="type-col">{item.wpn2_type != undefined ? item.wpn2_type : ""} </div> -->
<div id="type-col">{itemTypeText()} </div>

<style>
    #type-col {
        text-align: left;
    }
</style>
